import { Link } from "react-router-dom";

import { getPublicPage } from "../../seo/publicPages";
import { RELATED_GUIDES } from "../Articles/relatedGuideList";
import { ghiduriSection, resourceLinks } from "./landingContent";
import { LandingSection } from "./LandingPrimitives";

type LandingGuidesSectionProps = {
  titleAs?: "h1" | "h2";
};

function guideLabel(path: string): string {
  return resourceLinks.find((link) => link.href === path)?.label ?? getPublicPage(path).headline;
}

export default function LandingGuidesSection({
  titleAs = "h2",
}: LandingGuidesSectionProps) {
  return (
    <LandingSection
      id="ghiduri"
      eyebrow={ghiduriSection.eyebrow}
      title={ghiduriSection.title}
      description={ghiduriSection.description}
      titleAs={titleAs}
    >
      <div className="landing-guides-grid">
        {RELATED_GUIDES.map((guide) => {
          const page = getPublicPage(guide.path);
          const label = guideLabel(guide.path);
          return (
            <article key={guide.path} className="landing-guide-card">
              <Link
                to={guide.path}
                className="landing-guide-card__hit"
                aria-label={`Citește ghidul: ${label}`}
              >
                <h3 className="landing-guide-card__title">{label}</h3>
                <p className="landing-guide-card__description">{page.description}</p>
                <span className="landing-guide-card__cta" aria-hidden="true">
                  Citește ghidul
                  <span className="landing-guide-card__cta-arrow">→</span>
                </span>
              </Link>
            </article>
          );
        })}
      </div>
    </LandingSection>
  );
}
